import { useParams } from 'react-router-dom';

export default function usePublicReportId() {
    const { uuid } = useParams<{ uuid: string }>();
    return uuid;
}
